import { FC } from 'react';

import { ThemedImage } from '../Shared/components-v2/themed-image/ThemedImage';
import { RestThemedAsset, ThemedAsset } from '../Shared/data';

type Props = {
  name: string;
  asset: ThemedAsset | RestThemedAsset;
  size?: string;
};

export const AccountIcon: FC<Props> = ({ asset, name, size = '36px' }) => {
  const themedAsset = 'lightUrl' in asset ? { light: asset.lightUrl, dark: asset.darkUrl } : asset;

  return (
    <ThemedImage themedAsset={themedAsset} width={size} height={size} alt={name} css={{ borderRadius: '11.111111%' }} />
  );
};
